import { Divider, Text } from "@mantine/core";
import classes from "./ProjectCard.module.css";

export type TProjectCard = {
  title: string;
  description?: string;
  tech: string[];
  links: {
    title: string;
    href: string;
  }[];
};

export const ProjectCard = ({
  title,
  description,
  tech,
  links,
}: TProjectCard) => {
  return (
    <div className={classes["project-card"]}>
      <div className={classes["project-card-header"]}>
        <div className={classes["project-card-title"]}>{title}</div>
      </div>
      <div className={classes["project-card-body"]}>
        <div className={classes["project-card-description"]}>{description}</div>
        <Divider />
        <div>
          <div className={classes["tech-category"]}>
            <Text className={classes["tech-category-title"]}>Tech:</Text>
            <Text className={classes["tech-category-content"]}>
              {tech.join(", ")}
            </Text>
          </div>
        </div>
      </div>
    </div>
  );
};
